import { render, staticRenderFns } from "./BuildingEditDeliveryLetterTab.vue?vue&type=template&id=2ed88736"
import script from "./BuildingEditDeliveryLetterTab.vue?vue&type=script&lang=ts"
export * from "./BuildingEditDeliveryLetterTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports